import { useUserActivityStore } from "@/stores/UserActivityStore";

export const SlackUserActivityStores = [useUserActivityStore];

export const SlackUserActivityChannel = {
  received(payload) {
    this.userActivityStore.slackThreadId = payload;
  },
};
